import { useContext, useEffect, useState } from 'react'
import useAnalytics, { type SPContext, type SPEvent } from '@hooks/use-analytics'
import { BlockContext, PageContext } from '@lib/analytics'

export default () => {
  const [events, setEvents] = useState({})
  const [activeEventId, setActiveEventId] = useState('')
  const { track } = useAnalytics()

  const pageContext = useContext(PageContext)
  const blockContext = useContext(BlockContext)

  useEffect(() => {
    const activeEvent = events[activeEventId]

    if (activeEvent) {
      const activeEventTitle = activeEvent.title

      const contexts: SPContext[] = [
        {
          name: 'component',
          data: {
            component_text: activeEventTitle,
          },
        },
        {
          name: 'content',
          data: {
            content_type: activeEvent.sys.contentType.sys.id,
            content_internal_name: activeEvent.fields.heading || activeEventTitle,
            content_entry_id: activeEvent.sys.id,
            content_level: 'item',
          },
        }
      ]

      if (pageContext) contexts.push(pageContext)
      if (blockContext) contexts.push(blockContext)

      if (activeEvent.name === 'component_collapse') {
        track({
          event: { name: 'component_collapse', data: {} } as SPEvent,
          contexts,
        })
      } else {
        track({
          event: { name: 'component_expand', data: {} } as SPEvent,
          contexts,
        })
      }
    }
  }, [activeEventId, blockContext, events, pageContext, track])

  const handleCollapsibleAnalytics = (title: string | undefined, fields: any, sys: any) => {
    const id = sys.id

    if (events[id]?.name === 'component_expand') {
      setEvents(prevState => ({
        ...prevState,
        [id]: {
          name: 'component_collapse',
          title,
          fields,
          sys,
        }
      }))

      setActiveEventId(id)
    } else {
      setEvents(prevState => ({
        ...prevState,
        [id]: {
          name: 'component_expand',
          title,
          fields,
          sys,
        }
      }))

      setActiveEventId(id)
    }
  }

  return [handleCollapsibleAnalytics]
}
